import request from '@/axios'
import type { UserType } from './types'

interface RoleParams {
  roleName: string
}

export const loginApi = (data: UserType): Promise<IResponse<UserType>> => {
  return request.post({
    url: '/admin/login',
    data: {
      name: data.username,
      password: data.password,
      google2fa_code: data.google2fa_code
    }
  })
}

export const loginOutApi = (): Promise<IResponse> => {
  return request.post({ url: '/admin/logout' })
}

/**
 * 拉当前登录管理员的最新信息 + 菜单。
 *
 * 用途：F5 浏览器刷新后路由守卫调用，用最新菜单重建左侧菜单 + addRoute；
 * 解决「老板改了菜单/权限后必须退出重登才生效」的体验问题。
 *
 * 返回结构与 loginApi 的 data.user 一致（含 menus 字段），可无差别替换 userStore 里的菜单。
 */
export const getMeApi = (): Promise<IResponse<{ user: UserType }>> => {
  return request.get({ url: '/admin/me' })
}

/**
 * 高危操作二次校验 — 输入当前登录管理员的谷歌验证码。
 * 给 useGoogleAuth() composable 调用，仅校验不签发 token，每次高危操作都需要单独输码。
 */
export const verifyOtpApi = (code: string): Promise<IResponse> => {
  return request.post({ url: '/admin/auth/verify-otp', data: { code } })
}

/**
 * 当前登录管理员修改自己的密码。
 * 弱密码（黑名单）登录后强制改密弹窗、用户主动改密都调它。
 */
export const changeMyPasswordApi = (data: {
  current_password: string
  new_password: string
  new_password_confirmation: string
}): Promise<IResponse> => {
  return request.post({ url: '/admin/auth/change-my-password', data })
}

export const getUserListApi = ({ params }: AxiosConfig) => {
  return request.get<{
    code: string
    data: {
      list: UserType[]
      total: number
    }
  }>({ url: '/mock/user/list', params })
}

export const getAdminRoleApi = (
  params: RoleParams
): Promise<IResponse<AppCustomRouteRecordRaw[]>> => {
  return request.get({ url: '/mock/role/list', params })
}

export const getTestRoleApi = (params: RoleParams): Promise<IResponse<string[]>> => {
  return request.get({ url: '/mock/role/list2', params })
}
